module.exports = "<span ng-datepicker\r\n      default-date=\"initialDateV\"\r\n      start-view=\"{{startView}}\"\r\n      min-view=\"day\"\r\n      input-id=\"localDateChooser\"\r\n      name=\"localDateChooser\"\r\n      max-date=\"maxDateV\"\r\n      min-date=\"minDateV\"\r\n      ng-model=\"value\"></span>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/time/templates/local-date-chooser.html
// module id = 604
// module chunks = 0